<template>
	<div class="itModal">
		<div class="popupWrapper" style="background-image: url('/images/widgets/newsletter_popup_background.webp')">
			<i class="popupClose lnr icon-cross cursor-pointer p-1" @click="close()"></i>

			<div class="content d-flex justify-content-center flex-column align-items-center">

				<span class="text-success text-center font-semibold congratulations-text" v-if="success" style="font-size: 140%; margin-top:36%;">{{ __('newsletter.congratulations_text') }}</span>

				<template v-else>
					<img src="/images/widgets/subscribe_to_newsletter.png" alt="" class="mw-100">
					<p class="text-center mt-4">ABONEAZA-TE ACUM LA NEWSLETTER SI<br>
						<span class="text-primary" style="font-size: 150%;">PRIMESTI 10% REDUCERE</span><br> LA PRIMA COMANDA</p>

					<div class="form-control bg-transparent border-0 mt-3 d-flex justify-content-center">
						<input type="text" placeholder="Introdu adresa de email" class="rounded-5 p-2 border-0 w-100 mw-100" v-model="email" required>
					</div>

					<p class="mt-1 mb-2 text-center font-semibold text-danger" v-if="error">
						{{ __('enter_email_address') }}!</p>

					<div class="px-4 mt-2 d-flex justify-content-center" v-if="!error && !success">
						<button class="btn btn-primary w-100" @click="submit()">{{ __('subscribe') }}</button>
					</div>

				</template>

			</div>
		</div>
	</div>
</template>


<script>

import {validateEmail} from "@/utility";

export default {
	name: "NewsletterPopup",
	data() {
		return {

			disable_input: false,
			email: null,
			error: null,
			success: false
		}
	},

	watch: {
		email: function (val, oldVal) {
			this.error = null;
		}
	},

	mounted() {
		if (this.$page.props.auth?.user) {
			this.email = this.$page.props.auth.user.email
			this.disable_input = true;
		}
	},

	methods: {

		submit() {

			if (!this.email || !validateEmail(this.email)) {
				this.error = 'enter_email_address';
				return;
			}

			axios.post(route('newsletter.subscribe', {
				email: this.email
			})).then(r => {

				this.success = true;

				// Set in store after 3 seconds, causing the popup to close
				setTimeout(() => {
					this.$store.commit('central/set', {
						subscribed_to_newsletter: true
					})
				}, 3000);

			}).catch(error => {
				console.log(error);
			})

		},

		close(){
			this.$emit('hide');
			localStorage.setItem('newsletter_window_closed', true);
		}

	}
}

</script>